import * as React from "react";
import { Search, SearchX } from "lucide-react";
import { PatternFormat } from "react-number-format";
import { cn } from "@/lib/utils";

function InputFilterCPF({ className, setFilter, filter, ...props }) {
  const [value, setValue] = React.useState(filter || "");
  const [filterActive, setFilterActive] = React.useState(false);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    if (newValue === "") {
      setFilter(null);
      setFilterActive(false);
    }
  };

  const applyFilter = () => {
    if (value) {
      setFilter(value);
      setFilterActive(true);
    }
  };

  const clearFilter = () => {
    setValue("");
    setFilter(null);
    setFilterActive(false);
  };

  React.useEffect(() => {
    if (filter) {
      setFilterActive(true)
    }
  }, [filter]);

  return (
    <div className="relative flex items-center flex-1">
      <PatternFormat
        placeholder="Consultar aluno pelo CPF"
        format="###.###.###-##"
        autoComplete="cpf"
        value={value}
        onChange={handleChange}
        className={cn(
          "border-input file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
          "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
          className
        )}
        {...props}
      />
      {!filterActive && (
        <button
          type="button"
          onClick={applyFilter}
          className="absolute right-2 text-gray-500 hover:text-gray-700 cursor-pointer"
        >
          <Search size={20} />
        </button>
      )}
      {filterActive && (
        <button
          type="button"
          onClick={clearFilter}
          className="absolute right-2 text-red-500 hover:text-red-700 cursor-pointer"
        >
          <SearchX size={20} />
        </button>
      )}
    </div>
  );
}

export { InputFilterCPF };
